import { createFileRoute } from '@tanstack/react-router';
import { InvoiceEditorPage } from '@/features/finance';

/**
 * One invoice: editor for a draft, read-only viewer otherwise. Notifications and the progress
 * editor link here.
 */
export const Route = createFileRoute('/_auth/o/$orgId/finance/invoices/$invoiceId')({
  component: InvoiceRoute,
});

function InvoiceRoute() {
  const { orgId, invoiceId } = Route.useParams();
  return <InvoiceEditorPage orgId={orgId} invoiceId={invoiceId} />;
}
